








































































































import { Contact } from "../../services/contact/entities/contact.interface";
import privileges from "../../utils/privileges";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import constants from "../../config/constants";
import dateFn from "../../utils/date";
import DeleteContactDialog from "./DeleteContactDialog.vue";
interface ContactUI {
  id: number;
  email: string;
  name?: string;
  description?: string;
  date: string;
}
type ContactType = "billboard" | "contact-us";
@Component({
  components: {
    DeleteContactDialog,
  },
})
export default class ContactTable extends Vue {
  @Prop({ default: "billboard" })
  type!: ContactType;
  @Prop()
  currentType!: ContactType;
  selected: Contact | null = null;
  deleteDialog = false;
  loading = false;
  loadingDownload = false;
  snackbarSuccess = false;
  successMessage = "";
  snackbarError = false;
  errorMessage = "";
  pagination = {
    quantity: 10,
    totalItems: 0,
    start: 0,
  };
  options = {};
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;
  headers: Record<string, any>[] = [];
  @Watch("currentType")
  checkType(type: ContactType) {
    if (type == this.type) {
      this.pagination.start = 0;
      this.loadContacts();
    }
  }

  setSelected(contact: ContactUI) {
    this.selected = {
      contactEmail: contact.email,
      contactID: contact.id,
      contactType: this.type,
    };
  }
  get isContactUs() {
    return this.type == "contact-us";
  }
  async loadContacts() {
    this.loading = true;
    try {
      await this.$store.dispatch("contact/getContacts", {
        ...this.pagination,
        type: this.type,
      });
    } catch (error) {
      this.snackbarError = true;
      this.errorMessage = "cargar mensajes";
    }
    this.loading = false;
  }
  onTableChange(options: any) {
    this.pagination.quantity = options.quantity || this.pagination.quantity;
    this.pagination.start = options.page
      ? options.page - 1
      : this.pagination.start;
    this.loadContacts();
  }
  private mounted(): void {
    this.loadContacts();
    this.headers =
      this.type == "billboard"
        ? [
            {
              text: "E-mail",
              align: "start",
              sortable: false,
              value: "email",
            },
            {
              text: "Fecha de registro",
              align: "start",
              sortable: false,
              value: "date",
            },
            { text: "Acciones", value: "actions", sortable: false },
          ]
        : [
            {
              text: "E-mail",
              align: "start",
              sortable: false,
              value: "email",
            },
            {
              text: "Nombre",
              align: "start",
              sortable: false,
              value: "name",
            },
            {
              text: "Fecha de registro",
              align: "start",
              sortable: false,
              value: "date",
            },
            { text: "Acciones", value: "actions", sortable: false },
          ];
  }

  get contacts(): Array<ContactUI> {
    const contacts = this.$store.getters["contact/getContacts"];
    return (
      contacts?.map((contact: Contact) => {
        return {
          id: contact.contactID,
          email: contact.contactEmail,
          name: `${contact.contactFirstName} ${contact.contactLastName}`,
          description: contact.contactDescription,
          date: contact.contactDate && dateFn.formatDate(contact.contactDate),
        };
      }) || []
    );
  }
  get totalContacts(): number {
    return this.$store.getters["contact/getTotalContacts"] || 0;
  }
  onDelete(item: ContactUI): void {
    this.setSelected(item);
    this.deleteDialog = true;
  }
  onDeleteError() {
    this.snackbarError = true;
    this.errorMessage = "eliminar contacto";
  }
  onDeleteSuccess() {
    this.snackbarSuccess = true;
    this.successMessage = "Contacto eliminado";
    this.loadContacts();
  }
  async onDownload() {
    this.loadingDownload = true;
    try {
      await this.$store.dispatch("contact/exportContacts", this.type);
    } catch (error) {
      this.snackbarError = true;
      this.errorMessage = "exportar contactos";
    }
    this.loadingDownload = false;
  }
  checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }
}
